<template>
  <div class="hc-hexainception">
    <svg :style="style" class="hc-hexainception-chart">
      <g :transform="transform">
        <complexagon
          v-for="(d, index) in Data"
          :key="index"
          :value="1"
          :curve="curve"
          :onColor="colors[index]"
          :scale="getScale(d)"
          :y="getY(d)"
          :x="getX(d)"
          :strokeWidth="0"
          :bbox="getBBox(index)"
          :text="texts[index]"
          :textValue="parseInt(data[index]) + ' ' + unit"
          class="hc-hexainception-complexagon"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import Complexagon from '../combo/Complexagon'
import tween from '../libraries/tween'
export default {
  name: 'HexaInception',
  components: {
    Complexagon
  },
  props: {
    data: {
      type: Array,
      default () { return []}
    },
    texts: {
      type: Array,
      default () { return []}
    },
    unit: {
      type: String,
      default: 'MD'
    },
    colors: {
      type: Array,
      default () { return ['#666666', '#f56042']}
    },
    curve: {
      type: Number,
      default: .8
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Exponential',
          easingEdge: 'Out'
        }
      }
    }
  },
  data () {
    return {
      width: 420,
      height: 480,
      Data: []
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  created () {
    if (this.animation) {
      tween(
        Object.assign({}, this.data),
        Object.assign({}, this.data.map((d, i, arr) => {return  i ?  arr[i - 1] : arr[i + 1] })),
        this.animationDuration,
        (dataObject) => {
        this.Data = Object.keys(dataObject).map(function (key) { return dataObject[key] })
      }, this.animationOptions)
    } else {
      this.Data = this.data
    }
  },
  watch: {
    data: {
      handler (newData) {
        if (this.animation) {
          tween(
            Object.assign({}, newData),
            Object.assign({}, this.Data),
            this.animationDuration,
            (dataObject) => {
            this.Data = Object.keys(dataObject).map(function (key) { return dataObject[key] })
          }, this.animationOptions)
        } else {
          this.Data = newData
        }
      },
      deep: true
    }
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
    },
    getScale (value) {
      return this.scale * value / this.max
    },
    getY (value) {
      return (this.scale - this.getScale(value)) * -8
    },
    getX (value) {
      return (this.scale - this.getScale(value)) * -13.856
    },
    getBBox (index) {
      const ratio = this.Data[1] / this.data[0]
      if (index === 0) {
        return [ratio, ratio, 1 - ratio, 1 - ratio]
      } else {
        return [0, 0, 1, 1]
      }
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    max () {
      return this.data[0]
    },
    scale () {
      return 15 * Math.min(this.width / 420, this.height / 480)
    },
    transform () {
      return `translate(${13.856 * this.scale}, ${16 * this.scale})`
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
